import { useMemo } from "react";
import { selectors, useAppSelector } from "store";
import { BuildInfo } from "utility/buildinfo";
export var useCupTechnologyOptions = function (nodeIds) {
    var systemDataDefineParameters = useAppSelector(selectors.selectSystemDataDefineParameters);
    var currentlySelectedCupTechnology = useAppSelector(selectors.selectSelectedCupTechnologies(nodeIds));
    var cupTechnologyOptions = useMemo(function () {
        if (!(systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.cupTechnologyComponents))
            return [];
        return Object.values(systemDataDefineParameters.cupTechnologyComponents);
    }, [systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.cupTechnologyComponents]);
    var selectedCupTechnologyOptions = useMemo(function () {
        return cupTechnologyOptions.filter(function (option) {
            return option.value &&
                currentlySelectedCupTechnology
                    .map(function (tech) { return tech === null || tech === void 0 ? void 0 : tech.value; })
                    .includes(option.value);
        });
    }, [cupTechnologyOptions, currentlySelectedCupTechnology]);
    // we don't want to show cup technologies in production yet
    if (BuildInfo.environment === "production") {
        return {
            cupTechnologyOptions: [],
            selectedCupTechnologyOptions: [],
        };
    }
    return { cupTechnologyOptions: cupTechnologyOptions, selectedCupTechnologyOptions: selectedCupTechnologyOptions };
};
